/**批次路由 */
export default [
    {
        name:'batch',
        path:'batch',
        meta: { title: '批次管理' },
        component: ()=>import('@/pages/batch/index.vue')
    }
]